import angular from 'angular';

angular
  .module('cloudX')
  .controller('ConfirmTemplateChangesDialogCtrl', [
    '$scope',
    'appMessages',
    'close',
    'title',
    'message',
    'showResetDeviations',
    confirmTemplateChangesDialogCtrl,
  ]);

function confirmTemplateChangesDialogCtrl(
  $scope,
  appMessages,
  close,
  title,
  message,
  showResetDeviations,
) {
  $scope.title = appMessages(title);
  $scope.message = appMessages(message);
  $scope.showResetDeviations = showResetDeviations;
  $scope.resetDeviations = false;
  // Yes/No/Cancel and the checkbox value are returned together through the close payload.
  $scope.close = function(result) {
    close({ result: result, resetDeviations: !!$scope.resetDeviations }, 500);
  };
  $scope.cancel = function() {
    close({ result: null, resetDeviations: false }, 500);
  };
}
